var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveWorkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F7FC",
    d: "M4.5 21c-.55 0-1.021-.196-1.413-.588A1.922 1.922 0 0 1 2.5 19V8c0-.55.196-1.021.588-1.413A1.922 1.922 0 0 1 4.5 6h4V4c0-.55.196-1.021.588-1.413A1.922 1.922 0 0 1 10.5 2h4c.55 0 1.021.196 1.413.588.392.392.588.863.587 1.412v2h4c.55 0 1.021.196 1.413.588.392.392.588.863.587 1.412v11c0 .55-.196 1.021-.588 1.413A1.922 1.922 0 0 1 20.5 21h-16Zm0-2h16V8h-16v11Zm6-13h4V4h-4v2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveWorkIcon);
export default __webpack_public_path__ + "static/media/activeWorkIcon.e158a8def24856d6a4ef7ffb7bb7dc75.svg";
export { ForwardRef as ReactComponent };